// extracted by mini-css-extract-plugin
export default {"box":"operation-short-module_box-jwpY7","item":"operation-short-module_item-l6TiH"};